var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum1BlueBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.9512,
    r: 15.5,
    stroke: "#1167ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8135 22.9512V21.1662H15.1985V14.1462H13.1885V12.7812C14.2985 12.5712 15.0635 12.2862 15.7685 11.8362H17.4035V21.1662H19.4885V22.9512H12.8135Z",
    fill: "#1167ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum1BlueBorder);
export default __webpack_public_path__ + "static/media/icon_circleNum_1_blueBorder.ab43e7b44edab5c61b227a0efa4bb46e.svg";
export { ForwardRef as ReactComponent };